import Model from "./Model";

class Groups extends Model{
    getId() {
        return this.attrs.id;
    }
    
    setId(value) {
        this.attrs.id = value;
        return this;
    }

    getServiceId() {
        return this.attrs.serviceId;
    }
    
    setServiceId(value) {
        this.attrs.serviceId = value;
        return this;
    }
    getName() {
        return this.attrs.name;
    }
    
    setName(value) {
        this.attrs.name = value;
        return this;
    }

    getContactsList() {
        return this.attrs.contactsList;
    }
    
    setContactsList(value) {
        this.attrs.contactsList = value;
        return this;
    }

    getContactsCount() {
        return this.attrs.contactsCount;
    }
    
    setContactsCount(value) {
        this.attrs.contactsCount = value;
        return this;
    }

    getNotes() {
        return this.attrs.notes;
    }
    
    setNotes(value) {
        this.attrs.notes = value;
        return this;
    }

    getCreatedAt() {
        return this.attrs.createdAt;
    }
    
    setCreatedAt(value) {
        this.attrs.createdAt = value;
        return this;
    }

    getDescription() {
        return this.attrs.description;
    }
    
    setDescription(value) {
        this.attrs.description = value;
        return this;
    }

    getTotalMessages() {
        return this.attrs.totalMessages;
    }
    
    setTotalMessages(value) {
        this.attrs.totalMessages = value;
        return this;
    }
}
export default Groups;